import React, { useEffect } from "react";
import ContentHeader from "../contentHeader";
import Input from "../input";
import RoundButton from "../roundButton";

/**
 * CrudFormLayout — the shared visual shell for any CRUD form.
 *
 * This replaces the `render()` method of the old base class. The variable
 * part (the entity-specific fields) is passed in as `children`.
 */
export function CrudFormLayout({
  title,
  subTitle,
  extraButton,
  breadcrumbs,
  onSubmit,
  onExtraAction,
  crudForm,
  submitLabel = "Guardar",
  children,
}) {
  return (
    <>
      {renderContentHeader(title, breadcrumbs)}

      <section className="content">
        <div className="container-fluid">
          <div className="row ">
            {/* left column */}
            <div className="col-12">
              <div className="card card-secondary">
                <div className="card-header">
                  <div className="row justify-content-between">
                    <h3 className="card-title">
                      <RoundButton
                        onClick={() => crudForm.goBack()}
                        iconClass="fas fa-arrow-left"
                        className="btn-transparent mr-2"
                        tooltip="Volver"
                      />
                      {subTitle}
                    </h3>
                    {extraButton && (
                      <button className="btn btn-outline-light" onClick={() => onExtraAction(crudForm.data._id)}>
                        {extraButton}
                      </button>
                    )}

                    {crudForm.action === "C" && crudForm.permisos && crudForm.permisos.canModify && (
                      <div>
                        <button className="btn btn-outline-light mr-2" onClick={() => crudForm.setAction("E")}>
                          EDITAR
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {crudForm.mounted && (
                  <form onSubmit={onSubmit}>
                    <div className="card-body mt-2">
                      {children}
                      {crudForm.errors && crudForm.errors.length > 0 && (
                        <div className="row">
                          {
                            <h4 className="ml-4 text-danger is-invalid">
                              {crudForm.errors.map((error) => error.message)}
                            </h4>
                          }
                        </div>
                      )}
                    </div>
                    <div className="card-footer">
                      {/* {this.renderSubmit("Guardar")} */}
                      <Submit
                        label={submitLabel}
                        isEditingChild={crudForm.isEditingChild}
                        action={crudForm.action}
                        onSubmit={onSubmit}
                        goBack={() => {
                          crudForm.goBack();
                        }}
                        // isEditingChild={loading}
                      />
                    </div>
                  </form>
                )}
              </div>
            </div>
            {/* /.row */}
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
    </>

    // <form className="crud-form" onSubmit={onSubmit} noValidate>
    //   {title && <h2 className="crud-form__title">{title}</h2>}

    //   {errors._form && <p className="crud-form__error-banner">{errors._form}</p>}

    //   <div className="crud-form__fields">{children}</div>

    //   <div className="crud-form__actions">
    //     {onCancel && (
    //       <button type="button" className="crud-form__btn crud-form__btn--ghost" onClick={onCancel} disabled={loading}>
    //         Cancel
    //       </button>
    //     )}
    //     <button type="submit" className="crud-form__btn" disabled={loading}>
    //       {loading ? "Saving…" : submitLabel}
    //     </button>
    //   </div>
    // </form>
  );
}

const renderContentHeader = (title, breadcrumbs, back) => {
  return <ContentHeader title={title} breadcrumbs={breadcrumbs} />;
};

export function Submit({ label, action, onSubmit, goBack, isEditingChild }) {
  return (
    <>
      {action !== "C" && (
        <button type="button" onClick={onSubmit} disabled={isEditingChild} className="btn btn-secondary float-right">
          {label}
        </button>
      )}
      {action === "C" && (
        <button type="button" onClick={goBack} className="btn btn-secondary float-right">
          Volver
        </button>
      )}
    </>
  );
}

/**
 * Field — a small helper for a labelled input with inline error display.
 * Optional, but it keeps the specific forms tidy.
 */
export function Field({ name, label, crudForm, type = "text", promiseOptions, onCreateOption, ...inputProps }) {
  const action = crudForm.action;
  //   const { errors, data, action } = this.state;
  //   var inputProps = { ...extras };
  if (label) inputProps.label = label;
  // if (floatLabel) inputProps.float = "true";
  // if (size) inputProps.size = size;
  if (action === "C") {
    inputProps.disabled = true;
    if (type === "combo" || type === "asyncCombo" || type === "asyncCreatable") inputProps.isDisabled = true;
  }
  // else {
  //   delete inputProps.disabled;
  //   delete inputProps.isDisabled;
  // }
  type = type.toUpperCase();
  switch (type.toUpperCase()) {
    case "TOGGLE":
      inputProps.toggle = "true";
      break;
    case "RADIO":
      inputProps.radio = "true";
      break;
    case "CHECK":
      inputProps.check = "checkbox";
      break;
    case "DATE":
      inputProps.date = "true";
      break;
    case "INTEGER":
      inputProps.integer = "true";
      break;
    case "NUMBER":
      inputProps.number = "true";
      break;
    case "FLOAT":
      inputProps.float = "true";
      break;
    case "CUIT":
      inputProps.cuit = "true";
      break;
    case "CURRENCY":
      inputProps.currency = "true";
      break;
    case "TEXTAREA":
      inputProps.textarea = "true";
      break;
    case "PHONE":
      inputProps.phone = "true";
      break;
    case "DNI":
      inputProps.dni = "true";
      break;
    case "COMBO":
      // if (options) {
      inputProps.combo = true;
      //   inputProps.options = options;
      // }
      break;
    case "ASYNCCOMBO":
      inputProps.asyncCombo = true;
      break;
    case "ASYNCCREATABLE":
      inputProps.asyncCreatable = true;
      break;
    default:
      inputProps.type = "text";
  }

  return (
    <>
      {inputProps.asyncCombo && (
        <Input
          name={name}
          value={crudForm.data[name]}
          error={crudForm.errors[name]}
          // onChange={this.handleAsyncChange}
          onBlur={() => crudForm.handleSelectBlur(name)}
          onChange={crudForm.handleSelectChange}
          loadOptions={promiseOptions}
          {...inputProps}
        />
      )}

      {inputProps.combo && (
        <Input
          name={name}
          value={crudForm.data[name]}
          error={crudForm.errors[name]}
          onBlur={() => crudForm.handleSelectBlur(name)}
          onChange={crudForm.handleSelectChange}
          {...inputProps}
        />
      )}
      {inputProps.asyncCreatable && (
        <Input
          name={name}
          value={crudForm.data[name]}
          error={crudForm.errors[name]}
          onBlur={() => crudForm.handleSelectBlur(name)}
          onChange={crudForm.handleSelectChange}
          loadOptions={promiseOptions}
          onCreateOption={onCreateOption}
          {...inputProps}
        />
      )}
      {!inputProps.combo &&
        !inputProps.asyncCombo &&
        !inputProps.asyncCreatable &&
        !inputProps.toggle &&
        !inputProps.check &&
        inputProps.radio && (
          <Input
            name={name}
            action={crudForm.action}
            value={crudForm.data[name]}
            selectedValue={crudForm.data[name]}
            error={crudForm.errors[name]}
            onChange={(e) => {
              crudForm.handleChange(e);
            }}
            onBlur={crudForm.handleBlur}
            {...inputProps}
          />
        )}
      {!inputProps.combo &&
        !inputProps.asyncCombo &&
        !inputProps.asyncCreatable &&
        !inputProps.radio &&
        (inputProps.toggle || inputProps.check) && (
          <Input
            name={name}
            value={crudForm.data[name].toString()}
            error={crudForm.errors[name]}
            checked={crudForm.data[name]}
            onChange={(e) => {
              crudForm.handleChange(e);
            }}
            {...inputProps}
          />
        )}
      {!inputProps.combo &&
        !inputProps.asyncCombo &&
        !inputProps.asyncCreatable &&
        !inputProps.radio &&
        !(inputProps.toggle || inputProps.check) && (
          <Input
            name={name}
            action={crudForm.action}
            value={crudForm.data[name]}
            error={crudForm.errors[name]}
            onChange={(e) => {
              crudForm.handleChange(e);
            }}
            onBlur={crudForm.handleBlur}
            {...inputProps}
          />
        )}
    </>
  );
}
